/**
 * H2.js
 * Styled Component for H2
 */
import styled from 'styled-components'

// Styles
const Heading2 = styled.h2`
    color: ${props => props.theme.colors.headingColor};
`

export default Heading2;